var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header df-between",style:({
      'padding-top': _vm.utils.isIphoneX() ? '50px' : '30px',
      'background-color': _vm.bgColor,
      'z-index': _vm.zIndex
    })},[(_vm.isBack)?_c('i',{staticClass:"back",on:{"click":function($event){return _vm.handleBack()}}}):_vm._e(),_c('div',{staticClass:"title df-center"},[_vm._v(_vm._s(_vm.headTitle))]),(_vm.showRightTile)?_c('div',{staticClass:"right-title",on:{"click":_vm.rightTileClick}},[_vm._v(" "+_vm._s(_vm.rightTitle)+" ")]):_c('i',{staticClass:"iconfont"})]),_c('div',{staticClass:"holder",style:({
      'height': _vm.utils.isIphoneX() ? '89px' : '68px',
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }